import dayjs from "dayjs";
import {Order} from "../types/domain/order";
import {formatShortDate} from "./dateUtils";
import {OrderStatus} from "../types/domain/orderStatus";

const formatOrderDate = (date: string | undefined, format: string) => {
    return date ? formatShortDate(dayjs(date), format) : "";
};

export const getOrderPeriod = (order: Order, format: string): string => {
    return `${formatOrderDate(order.startDate, format)} - ${formatOrderDate(order.endDate, format)}`;
};

export const getOrderConfirmPageUrl = (companyId: string, orderId: string): string => {
    return `/orders/${companyId}/${orderId}/confirm`;
};

// Order status should be ordedred. Meaning you can transcition only to the next stage.
// We don't use all the status, because COMPLETE comes from pipelines, we can't change it manually.
export const ORDER_STATUS_ORDERED: OrderStatus[] = [
    OrderStatus.NEW,
    OrderStatus.UNDER_REVIEW,
    OrderStatus.AWAITING_CONFIRMATION,
    OrderStatus.ACTIVE,
];

export const ORDER_STATUS_COLORS: Record<OrderStatus, {color: string; borderColor: string}> = {
    [OrderStatus.NEW]: {color: "#DBDEE6", borderColor: "#CACDD8"},
    [OrderStatus.UNDER_REVIEW]: {color: "#FED976", borderColor: "#FEB24C"},
    [OrderStatus.AWAITING_CONFIRMATION]: {color: "#FED976", borderColor: "#FEB24C"},
    [OrderStatus.ACTIVE]: {color: "#2AFD7A", borderColor: "#2196F3"},
    [OrderStatus.PAUSED]: {color: "#FDBBB1", borderColor: "#F89083"},
    [OrderStatus.CANCELED]: {color: "#DBDEE6", borderColor: "#CACDD8"},
    [OrderStatus.COMPLETED]: {color: "#DBDEE6", borderColor: "#CACDD8"},
};
